import { useEffect, useState, useCallback } from 'react';
import { sellerApi } from '../sellerAuth';

const QKEY = 'flix_offline_queue';

const read = () => { try { return JSON.parse(localStorage.getItem(QKEY) || '[]'); } catch { return []; } };
const write = (q) => localStorage.setItem(QKEY, JSON.stringify(q));

// Offline queue for manual (cash) sales. Card charges require connectivity (Stripe).
export const useOfflineQueue = (onSynced) => {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(read().length);

  const flush = useCallback(async () => {
    let q = read();
    if (!q.length || !navigator.onLine) { setPending(q.length); return; }
    const remaining = [];
    for (const item of q) {
      try {
        await sellerApi.post('/seller/manual-sale', item);
      } catch (e) {
        remaining.push(item); // keep for retry
      }
    }
    write(remaining);
    setPending(remaining.length);
    if (remaining.length < q.length && onSynced) onSynced();
  }, [onSynced]);

  const enqueue = useCallback((sale) => {
    const item = { ...sale, client_id: `off_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`, created_at: new Date().toISOString() };
    const q = read();
    q.push(item);
    write(q);
    setPending(q.length);
    flush();
    return item.client_id;
  }, [flush]);

  useEffect(() => {
    const goOnline = () => { setOnline(true); flush(); };
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    flush();
    return () => { window.removeEventListener('online', goOnline); window.removeEventListener('offline', goOffline); };
  }, [flush]);

  return { online, pending, enqueue, flush };
};
